import Alert from '@mui/material/Alert';
import { Localized } from 'dg-web-shared/lib/Localization.tsx';
import {
    RequestStatus,
    ServerRequestState,
} from 'dg-web-shared/lib/hooks/ServerStateHooks.ts';
import { GenericFormError } from 'dg-web-shared/common/utils/FormHooksUtils.tsx';
import { envIsProduction } from 'dg-web-shared/lib/Environment.ts';
import { Box } from '@mui/material';
import { parkingaboUrl } from '../utils/UrlUtil.ts';
import { SxProps } from '@mui/system';
import { Theme } from '@mui/material/styles';

export function GenericFormSubmitError({
    error,
    sx,
    submitState,
}: {
    error: GenericFormError | null;
    sx?: SxProps<Theme>;
    submitState?: ServerRequestState<unknown, unknown>;
}) {
    if (!error) {
        return null;
    }

    if (error.isGenericServerError) {
        return (
            <Alert
                severity="error"
                sx={[
                    { margin: '0 0 16px 0' },
                    ...(Array.isArray(sx) ? sx : [sx]),
                ]}
            >
                <>
                    <Localized
                        de="The request returned an error: status "
                        fr="The request returned an error: status "
                        it="The request returned an error: status "
                        en="The request returned an error: status "
                    />
                    {submitState?.status === RequestStatus.ERROR &&
                        submitState.httpStatusCode}
                </>
            </Alert>
        );
    }

    return (
        <>
            {error.issues.map(e => (
                <Alert
                    key={JSON.stringify(e.issue.message)}
                    severity="error"
                    sx={[
                        { margin: '0 0 16px 0' },
                        ...(Array.isArray(sx) ? sx : [sx]),
                    ]}
                >
                    <Localized {...e.issue.humanReadableMessage.byLanguage} />
                </Alert>
            ))}
        </>
    );
}

export function ParkingaboTestValidationLink({
    badgeLabelNr,
}: {
    badgeLabelNr: string | null;
}) {
    if (envIsProduction() || !badgeLabelNr) {
        return null;
    }

    // ignore Parkingpay badges (have only numbers)
    if (/^[0-9]+$/.test(badgeLabelNr)) {
        return null;
    }

    const validationUrl = `${parkingaboUrl()}/b/${badgeLabelNr}`;
    return (
        <Box
            sx={{
                fontStyle: 'italic',
                marginTop: '12px',
            }}
        >
            <span>Nur nicht PROD:</span>
            <br />
            <a href={validationUrl} target="_blank" rel="noreferrer">
                {validationUrl}
            </a>
        </Box>
    );
}
